import PropTypes from 'prop-types';
import React from 'react';

class YouTubeVideo extends React.PureComponent {
    static propTypes = {
        id: PropTypes.string.isRequired,
    };
    constructor(props) {
        super(props);

        this.state = {
            videoId: props.id.split('/').pop(),
        };
    }

    componentDidMount = () => {
        this.setState({ videoId: this.props.id.split('/').pop() });
        if (!window.YT) { // If not, load the script asynchronously
            const tag = document.createElement('script');
            tag.src = 'https://www.youtube.com/iframe_api';

            // onYouTubeIframeAPIReady will load the video after the script is loaded
            window.onYouTubeIframeAPIReady = this.loadVideo;

            const firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        } else { // If script is already there, load the video directly
            this.loadVideo();
        }
    };

    loadVideo = () => {
        const { videoId } = this.state;
        // the Player object is created uniquely based on the id in props
        this.player = new window.YT.Player(`youtube-player-${videoId}`, {
            videoId: videoId,
            width: '100%',
            playerVars: { 'autoplay': 1, 'playsinline': 1, 'mute': 1 },
            events: {
                onReady: this.onPlayerReady,
            },
        });
    };

    onPlayerReady = event => {
        event.target.mute();
        event.target.playVideo();
    };

    render = () => {
        const { videoId } = this.state;
        return (
            <div id={`youtube-player-${videoId}`} />
        );
    };
}

export default YouTubeVideo;